var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOcatagon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.86 2H16.14L22 7.86V16.14L16.14 22H7.86L2 16.14V7.86L7.86 2Z",
    stroke: "url(#paint0_linear_1416_44761)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5603 8.38L8.7683 7.6H9.9683V16H8.5883V9.076L6.8963 9.556L6.5603 8.38ZM15.9451 11.632C16.7691 12.088 17.1811 12.768 17.1811 13.672C17.1811 14.432 16.9131 15.036 16.3771 15.484C15.8491 15.932 15.1371 16.156 14.2411 16.156C13.3451 16.156 12.6291 15.936 12.0931 15.496C11.5571 15.056 11.2891 14.448 11.2891 13.672C11.2891 13.24 11.3971 12.848 11.6131 12.496C11.8291 12.136 12.1331 11.848 12.5251 11.632C11.8931 11.216 11.5771 10.624 11.5771 9.856C11.5771 9.088 11.8331 8.496 12.3451 8.08C12.8651 7.656 13.4971 7.444 14.2411 7.444C14.9771 7.444 15.6051 7.656 16.1251 8.08C16.6451 8.504 16.9051 9.096 16.9051 9.856C16.9051 10.616 16.5851 11.208 15.9451 11.632ZM14.2411 8.752C13.8571 8.752 13.5451 8.856 13.3051 9.064C13.0731 9.264 12.9571 9.548 12.9571 9.916C12.9571 10.268 13.0771 10.552 13.3171 10.768C13.5571 10.976 13.8651 11.08 14.2411 11.08C14.6091 11.08 14.9131 10.976 15.1531 10.768C15.4011 10.552 15.5251 10.268 15.5251 9.916C15.5251 9.548 15.4051 9.264 15.1651 9.064C14.9251 8.856 14.6171 8.752 14.2411 8.752ZM14.2411 14.848C14.7131 14.848 15.0891 14.732 15.3691 14.5C15.6571 14.268 15.8011 13.948 15.8011 13.54C15.8011 13.132 15.6571 12.812 15.3691 12.58C15.0891 12.348 14.7131 12.232 14.2411 12.232C13.7611 12.232 13.3771 12.348 13.0891 12.58C12.8091 12.812 12.6691 13.132 12.6691 13.54C12.6691 13.948 12.8091 14.268 13.0891 14.5C13.3771 14.732 13.7611 14.848 14.2411 14.848Z",
    fill: "url(#paint1_linear_1416_44761)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1416_44761",
    x1: 12,
    y1: -9.26621,
    x2: -10.5324,
    y2: 10.7338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E4AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504968,
    stopColor: "#10C5E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9240DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1416_44761",
    x1: 12,
    y1: -3.44966,
    x2: -4.06859,
    y2: 7.96045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E4AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504968,
    stopColor: "#10C5E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9240DC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOcatagon);
export default __webpack_public_path__ + "static/media/ocatagon.5010e79cd045d7ee325fe99207a74254.svg";
export { ForwardRef as ReactComponent };